import { combineReducers } from 'redux'
import operations from './operationsReducer'
import consumerApi from './consumerApiReducer'
import shogun from './shogunReducer'
import dataquest from './dataquestReducer'
import monitoring from './monitoringReducer'

const rootReducer = combineReducers({
  operations,
  consumerApi,
  shogun,
  dataquest,
  monitoring
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/index.js